// extracted by mini-css-extract-plugin
export default {"classificationFiltersContainer":"classificationFilters_classificationFiltersContainer__vu5YY","collapsableComponent":"classificationFilters_collapsableComponent__oQb3y"};